import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store/store';
import CryptoJS from 'crypto-js';
import spinner from '../../assets/spinner.svg';
import clock from '../../assets/clock.svg';
import { FaCreditCard } from 'react-icons/fa';

const ThailandPayment = ({ providers = [] }) => {
  const { paymentData, setPaymentData } = useStore();
  const [paymentPending, setBeforePayment] = useState(true);
  const [paymentID, setPaymentID] = useState(null);
  const [appointmentID, setAppointmentID] = useState(null);
  const [startTimer, setStartTimer] = useState(false);
  const [minutes, setMinutes] = useState(9);
  const [seconds, setSeconds] = useState(0);
  const [data, setData] = useState(null);
  const [autoCall, setAutoCall] = useState(false);
  const [loadingProvider, setLoadingProvider] = useState(null);
  const countDownRef = useRef(null);
  const pollingRef = useRef(null);
  const autocalledRef = useRef(false);
  const navigate = useNavigate();
  const decryptKey = 'secret';

  const PROVIDER_ICONS = {
    '2C2P': <FaCreditCard size={18} />,
  };
  const PROVIDER_COLORS = {
    '2C2P': '#0057D9',
  };

  useEffect(() => {
    try {
      //  Read query param
      const params = new URLSearchParams(window.location.search);
      const encodedData = params.get('data');

      //  Decode URL encoding
      const encrypted = decodeURIComponent(encodedData);

      // Decrypt
      const bytes = CryptoJS.AES.decrypt(encrypted, decryptKey);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) return;

      const decryptedData = JSON.parse(decryptedText);
      // Store data from url
      setData(decryptedData);
      setPaymentData(decryptedData);
    } catch (error) {
      console.error(error);
    }
  }, []);

  // Call Api to open payment gateway
  useEffect(() => {
    if (!data) return; // wait until data is ready
    if (autocalledRef.current) return; // prevent double call
    if (providers.length === 0) return;

    autocalledRef.current = true;
    setAutoCall(true);
    // Auto open payment gateway after 1.2 seconds
    setTimeout(() => {
      openPayment(providers[0]); // open first provider by default
    }, 1200);
  }, [data]);

  //open 2c2p PAYMENT
  const openPayment = (payment_method) => {
    setLoadingProvider(payment_method);
    const myHeaders = new Headers();
    myHeaders.append('db_ptr', data.customHeaders.db_ptr);
    myHeaders.append('mode', 'booking');
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', data.customHeaders.Authorization);
    console.log(
      'myHeaders',
      data.customHeaders.db_ptr,
      data.customHeaders.Authorization
    );
    const bodyData = {
      paymentRefId: data.paymentRefId,
      paymentProvider: payment_method.toLowerCase(),
    };
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(bodyData),
      redirect: 'follow',
    };

    fetch(
      'https://nurath-payment-api.onedesk.app/payment/initiate-order',
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          window.location.href = result.data.directUrl;
        } else {
          setLoadingProvider(null);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoadingProvider(null);
      });
  };

  return (
    <>
      <div
        className={'vertical-padding-32 '}
        style={{
          background: 'linear-gradient(180deg, #FBF9EE 5.29%, #82B8EE 72.12%)',
        }}
      >
        <div
          style={{
            width: '83%',
            position: 'relative',
            height: '90vh',
            margin: 'auto',
          }}
        >
          {' '}
          {paymentPending && (
            <div className="slotContainer margin-bottom-24">
              <div className="vertical-padding-32 ">
                <div className="row slotRowContainer justify-center">
                  <div className="margin-right-24 text-coal-dark firstChild">
                    <div className="title-2 margin-bottom-12">
                      Choose how you’d like to pay
                    </div>
                    <div
                      className="bg-slate-100 border-radius-6 padding-16"
                      style={{
                        boxShadow:
                          ' 0px 1.444px 5.778px 0px rgba(80, 114, 169, 0.12)',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '12px',
                        }}
                      >
                        {providers.map((provider) => (
                          <button
                            key={provider}
                            onClick={() =>
                              !loadingProvider && openPayment(provider)
                            }
                            disabled={!!loadingProvider}
                            className="primary-btn-large  enabled body-1 medium margin-bottom-12"
                            style={{
                              backgroundColor: PROVIDER_COLORS[provider],
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '10px',
                              borderRadius: '8px',
                              opacity: loadingProvider ? 0.8 : 1,
                              cursor: loadingProvider
                                ? 'not-allowed'
                                : 'pointer',
                            }}
                          >
                            {loadingProvider === provider ? (
                              <img
                                src={spinner}
                                alt="loading"
                                style={{ width: '20px', height: '20px' }}
                              />
                            ) : (
                              PROVIDER_ICONS[provider]
                            )}
                            <span>Pay with {provider}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {startTimer && (
            <div style={{ margin: 'auto', height: '100%' }}>
              <div
                className="col flex-center-align justify-center bg-white border-radius-12 padding-32"
                style={{ width: '27%', margin: 'auto', height: 'max-content' }}
              >
                <div>
                  <img src={spinner} alt="waiting for appointment id" />
                </div>
                <div className="vertical-margin-32 text-coal-dark text-center-align">
                  <div className="title-5 strong ">
                    {minutes > 5
                      ? 'Processing your payment...'
                      : 'Still processing your payment...'}
                  </div>
                  <div className="vertical-margin-4 body-1 regular">
                    {minutes > 5
                      ? 'This may take a moment. Please don’t refresh or close the window.'
                      : 'If you’ve been charged but haven’t received confirmation, don’t worry—we’ll update you shortly.'}
                  </div>
                  <div className="row flex-center-align justify-center">
                    <img
                      className="margin-right-4"
                      src={clock}
                      alt="It may take upto 10 minutes"
                    />

                    <div className="text-grey-500">{`${minutes}:${seconds < 10 ? '0' + seconds : seconds}`}</div>
                  </div>
                </div>
                <div className="text-slate-700">Need Help? Contact Support</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ThailandPayment;
